"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _slicedToArray2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/slicedToArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _trtcJsSdk = _interopRequireDefault(require("trtc-js-sdk"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "compDeviceSelect",
  props: {
    deviceType: {
      type: String
    }
  },
  data: function data() {
    return {
      deviceList: [],
      activeDevice: {},
      activeDeviceId: ""
    };
  },
  methods: {
    getDeviceList: function () {
      var _getDeviceList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this$deviceList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.deviceType;
              _context.next = _context.t0 === "camera" ? 3 : _context.t0 === "microphone" ? 7 : _context.t0 === "speaker" ? 11 : 15;
              break;
            case 3:
              _context.next = 5;
              return _trtcJsSdk.default.getCameras();
            case 5:
              this.deviceList = _context.sent;
              return _context.abrupt("break", 16);
            case 7:
              _context.next = 9;
              return _trtcJsSdk.default.getMicrophones();
            case 9:
              this.deviceList = _context.sent;
              return _context.abrupt("break", 16);
            case 11:
              _context.next = 13;
              return _trtcJsSdk.default.getSpeakers();
            case 13:
              this.deviceList = _context.sent;
              return _context.abrupt("break", 16);
            case 15:
              return _context.abrupt("break", 16);
            case 16:
              console.log(this.deviceType, this.deviceList);
              _this$deviceList = (0, _slicedToArray2.default)(this.deviceList, 1);
              this.activeDevice = _this$deviceList[0];
              this.activeDeviceId = this.deviceList[0].deviceId;
              this.$emit("change", this.activeDeviceId);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDeviceList() {
        return _getDeviceList.apply(this, arguments);
      }
      return getDeviceList;
    }(),
    handleChange: function handleChange() {
      this.$emit("change", this.activeDeviceId);
    }
  },
  mounted: function mounted() {
    var _this = this;
    navigator.mediaDevices.getUserMedia({
      audio: true,
      video: true
    }).then(function () {
      _this.getDeviceList();
    });
    navigator.mediaDevices.addEventListener("devicechange", this.getDeviceList);
  },
  beforeDestroy: function beforeDestroy() {
    navigator.mediaDevices.removeEventListener("devicechange", this.getDeviceList);
  }
};
exports.default = _default;